<template>
  <section v-show="isVisible" class="reports">
    <WhiteBlock :header="$t('account.reports.header')" :modifiers="[BLOCK_MODIFIERS.hasTable]">
      <CompleteYourReportTeaser />

      <Table>
        <TableRow>
          <TableCell
            class="reports__cell-head reports__cell-head--year"
            :modifiers="[CELL_MODIFIERS.head]"
            role="columnheader"
          >
            <div class="reports__cell-head-inner-year">
              {{ $t('account.reports.year') }}
            </div>
          </TableCell>
          <TableCell
            class="reports__cell-head reports__cell-head--last-modified"
            :modifiers="[CELL_MODIFIERS.head]"
            role="columnheader"
          >
            {{ $t('account.reports.lastModified') }}
          </TableCell>
          <TableCell
            class="reports__cell-head reports__cell-head--status"
            :modifiers="[CELL_MODIFIERS.head]"
            role="columnheader"
          >
            {{ $t('account.reports.status.label') }}
          </TableCell>
          <TableCell role="columnheader" />
        </TableRow>
        <ReportsTableRow
          v-for="year in listOfReportYears"
          :key="year"
          :year="year"
          :lastModified="getStatusUpdatedAt(year)"
          :status="getReportStatus(year)"
          :routerLink="getRowLink(year)"
        />
      </Table>
    </WhiteBlock>
  </section>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { ROUTE_NAMES } from '@/constants/route-names'
import { waitFor } from '@/helpers/time'
import WhiteBlock, { BLOCK_MODIFIERS } from '@/components/WhiteBlock/WhiteBlock.vue'
import CompleteYourReportTeaser from '@/components/Account/CompleteYourReportTeaser.vue'
import Table from '@/components/Table.vue'
import TableRow from '@/components/TableRow.vue'
import TableCell, { CELL_MODIFIERS } from '@/components/TableCell.vue'
import ReportsTableRow from '@/components/Account/Reports/ReportsTableRow.vue'

export default {
  name: 'ReportsIndex',
  meta: {
    isRequiringAuth: true,
  },

  components: {
    WhiteBlock,
    CompleteYourReportTeaser,
    Table,
    TableRow,
    TableCell,
    ReportsTableRow,
  },

  data() {
    return {
      BLOCK_MODIFIERS,
      CELL_MODIFIERS,
    }
  },

  computed: {
    ...mapState('page', ['isVisible']),
    ...mapState('account', ['isCurrentUserFetched']),
    ...mapState('report', ['reports']),

    ...mapGetters({
      isMqLarge: 'viewport/isMqLarge',
      listOfReportYears: 'report/listOfReportYears',
      getReportStatus: 'report/getReportStatus',
    }),
  },

  mounted() {
    waitFor(this, () => this.isCurrentUserFetched).then(() => this.showPage())
  },

  methods: {
    ...mapActions({
      showPage: 'page/show',
    }),

    getRowLink(year) {
      return this.localePath({ name: ROUTE_NAMES.reports.year, params: { year } })
    },

    getStatusUpdatedAt(year) {
      const report = this.reports.find(report => report.year === year)
      if (!report) return

      const updatedAt = report.statusUpdatedAt || report.updatedAt

      return updatedAt ? new Date(updatedAt) : undefined
    },
  },
}
</script>

<style lang="scss" scoped>
.reports {
  @include max-screen($mq-large) {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
  }

  &__cell-head {
    padding-right: 34px;

    @include max-screen(between($mq-medium, $mq-large)) {
      padding-right: 24px;
    }

    @include min-max-screen($mq-large, $mq-larger) {
      padding-right: 24px;
    }

    &--year {
      padding-right: 28px;
      width: 90px;

      @include min-screen($mq-medium) {
        width: auto;
      }

      @include max-screen(between($mq-medium, $mq-large)) {
        padding-right: 20px;
      }

      @include max-screen($mq-medium) {
        padding-right: 8px;
      }

      @include min-max-screen($mq-large, $mq-larger) {
        width: 20%;
        padding-right: 20px;
      }
    }

    &--status {
      width: 70%;

      @include min-screen($mq-large) {
        width: 45%;
      }
    }
  }

  &__cell-head-inner-year {
    width: 70px;
  }

  &::v-deep .table__cell:nth-child(2) {
    @include max-screen($mq-larger) {
      display: none;
    }
  }
}
</style>
